import React from 'react';

const CommunityImg = (props) => {
  return (
    <img
      loading="lazy"
      {...props}
    />
  )
}

export default CommunityImg ;